export default __webpack_public_path__ + "static/media/metamaskicon.fe8941aa.svg";